var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aui-wrapper"},[_c('NavBar'),_c('RightSideBar'),_c('Search'),_c('div',{staticClass:"main-box"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }